import { useCallback, useState } from "react";

import { EnumInputType } from "@enums";

export const usePasswordVisibility = (inputType?: string) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = useCallback(() => {
    setIsVisible((visible) => !visible);
  }, []);

  const isPasswordField = inputType === EnumInputType.Password;

  return {
    isVisible,
    isPasswordField,
    toggleVisibility,
    resolvedInputType:
      isPasswordField && isVisible ? EnumInputType.Text : inputType,
  };
};
